<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">Performance Score</div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container psi-body">
      <p class="sac__font-14 n70">
        A Performance Score is a technician-run test that shows how efficiently
        a system is working compared to how it performed when it was new.
      </p>

      <div class="psi-divider" />

      <div class="psi-section">
        <h3 class="sac__font-16 med">What affects a system's score?</h3>
        <p class="sac__font-14 n70">During testing, technicians evaluate:</p>
        <ul class="psi-list sac__font-14 n70">
          <li>Airflow</li>
          <li>Refrigerant levels</li>
          <li>System age</li>
          <li>Overall condition and cleanliness of key components</li>
        </ul>
        <p class="sac__font-14 n70">
          A score is then generated for the tested mode,
          heating or cooling, along with a brief explanation.
        </p>
      </div>

      <div class="psi-grades">
        <img src="@shared/assets/img/performance-score/grade-a.svg" alt="Grade A" class="psi-grade-img" />
        <img src="@shared/assets/img/performance-score/grade-b.svg" alt="Grade B" class="psi-grade-img" />
        <img src="@shared/assets/img/performance-score/grade-c.svg" alt="Grade C" class="psi-grade-img" />
        <img src="@shared/assets/img/performance-score/grade-d.svg" alt="Grade D" class="psi-grade-img" />
      </div>

      <div class="psi-notice">
        <img
          src="@shared/assets/img/general/info-grey.svg"
          alt="info"
          class="psi-notice-icon"
        >
        <span class="sac__font-14 n70">
          Systems that are 10+ years can only score up to a B.
        </span>
      </div>

      <div class="psi-divider" />

      <div class="psi-section">
        <h3 class="sac__font-16 med">What if system scores low?</h3>
        <p class="sac__font-14 n70">
          If system score is low, an option to schedule service directly
          from the test results is available.
        </p>
      </div>

      <div class="psi-app-preview">
        <img
          src="@shared/assets/img/performance-score/app-preview.png"
          alt="Performance Score app preview"
          class="psi-app-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'PerformanceScoreInfo',
  mixins: [customerDetailMixin],
};
</script>

<style lang="scss" scoped>
.psi-body {
  gap: 16px;
  overflow-y: auto;
}

.psi-divider {
  height: 1px;
  background-color: $NBLUE10;
}

.psi-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.psi-list {
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 4px;
  }
}

.psi-grades {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.psi-grade-img {
  width: 48px;
  height: 48px;
}

.psi-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: $NBLUE5;
  border-radius: 8px;
  padding: 12px 16px;

  .psi-notice-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin-top: 1px;
  }
}

.psi-app-preview {
  display: flex;
  justify-content: center;
  padding: 8px 0;

  .psi-app-img {
    max-width: 240px;
    width: 100%;
    height: auto;
    border-radius: 12px;
  }
}
</style>
